import { del } from './axios_call';

export default (hash) => del('catalogue', hash);
